import { BseDto, NegotiationRoundDto } from "../../autogen/bff-api";

export const eventIsCompleted = ({ event, round }: { event: BseDto; round?: NegotiationRoundDto }): boolean => {
  if (event.status === "Awarded") return true;
  if (round) return round.stateName === "Completed";
  return event.status === "Completed";
};
